import { render } from "./taskTicket.vue?vue&type=template&id=3bed329e"
import script from "./taskTicket.vue?vue&type=script&lang=js"
export * from "./taskTicket.vue?vue&type=script&lang=js"

import "./taskTicket.vue?vue&type=style&index=0&id=3bed329e&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__